import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "./api";

/**
 * Calls POST /api/translate (cached MongoDB on the server) to translate a
 * batch of short Italian strings into the user-selected language. Returns a
 * mapping `{ originalString: translatedString }`. When the language is
 * Italian the mapping is empty (caller falls back to the original string).
 *
 * @param {string[]} texts deduped list of Italian source strings
 * @returns {{ map: Object, tx: (s: string|null) => string|null }}
 */
export default function useDescTranslate(texts) {
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage || i18n.language || "it";
    const [map, setMap] = useState({});

    useEffect(() => {
        if (lang === "it") { setMap({}); return; }
        const list = Array.from(new Set((texts || []).map((s) => (s || "").trim()).filter(Boolean)));
        if (!list.length) { setMap({}); return; }
        let cancelled = false;
        api.post("/translate", { target_lang: lang, texts: list })
            .then((r) => { if (!cancelled) setMap(r.data?.translations || {}); })
            .catch(() => { if (!cancelled) setMap({}); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang, JSON.stringify(texts || [])]);

    const tx = (s) => (s && map[s.trim()]) || s;
    return { map, tx };
}
